import { Checkbox, DatePicker, Form, Input, Radio, Tabs, message } from "antd";
import BoxContainer from "base/ui/components/BoxContainer";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
// icons
import PageWrapper from "pages/Components/PageWrapper";
import { useTranslation } from "react-i18next";
import { DATE_FORMAT_POST, SYSTEM_TITLE } from "utils/constants";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { SearchForm, SearchItem } from "pages/Components/SearchBox";
import CustomInputString from "base/ui/components/Input/customInputString";
import CustomSelect from "base/ui/components/CustomSelect";
import { CommonModel } from "services/Main/common_services";
import ReactQuill from "react-quill";
import CustomButton from "base/ui/components/Button";
import { ROUTES } from "base/routes/routes";
import { ProColumns } from "@ant-design/pro-components";
import { ContactSegmentModel } from "services/Main/contactSegment_services";
import CustomProTable from "base/ui/components/CustomTable";
import { formatNumber } from "utils/formatHelper";
import { useCheckPermission } from "utils/permissionHelper";
import { CustomerUnidentifiedModel } from "services/Main/customerUnidentified_services";
import Editor from "base/ui/components/Editor";
import { Download } from "base/ui/components/Icons";
import { commonPresenter, commonStore, customerUnindentifiedPresenter, customerUnindentifiedStore } from 'stores/root_store';
import dayjs from 'dayjs';

const createDetailCustomerUnidentified = () => {
  return observer(() => {
    useCheckPermission("CREATE");
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t("page-title.kh-cdd") + " - " + SYSTEM_TITLE;

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const location = useLocation()
    const stateProps: any = location.state



    // lấy id của tab (nếu như có id là tab xem chi tiết)
    const tabId = searchParams.get("tabId");
    const typeTab = searchParams.get("type");

    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------
    // công ty
    const [listSaleOrg, setListSaleOrg] = useState<CommonModel[]>([]);
    const [editorContent, setEditorContent] = useState("");
    //--- DATA TABLE ------------------------------------------------------------

    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const [columns, setColumns] = useState<
      ProColumns<CustomerUnidentifiedModel>[]
    >([
      {
        title: t("zalo-notification.stt"),
        dataIndex: "stt",
        key: "stt",
        fixed: "left",
        width: 70,
        align: "center",
      },

      //  Nguồn
      {
        title: t("unidentified.nguon"),
        dataIndex: "source",
        key: "source",
        fixed: "left",
        width: 200,
      },
      // id
      {
        title: "ID",
        dataIndex: "customerCode",
        key: "customerCode",
        width: 70,
        fixed: "left",
      },
      // Thiết bị
      {
        title: t("unidentified.thiet-bi"),
        dataIndex: "deviceName",
        key: "deviceName",
        width: 150,
      },
      // Tên
      {
        title: t("unidentified.ten"),
        dataIndex: "customerName",
        key: "customerName",
        width: 150,
        // render: (text, record) => <Link to={''}>{text}</Link>,
      },
      //   Email
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 250,
      },
      //   Số điện thoại
      {
        title: t("unidentified.sdt"),
        dataIndex: "phone",
        key: "phone",
        width: 100,
      },
      //   Truy cập lần đầu
      {
        title: t("unidentified.truy-cap-lan-dau"),
        dataIndex: "firstVisit",
        key: "firstVisit",
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY",
        },
        width: 120,
        onCell: (_, index) => ({
          className: "text-center",
        }),
      },
      //  Lượt truy cập 30 ngày qua
      {
        title: t("unidentified.tc-30day"),
        dataIndex: "visitsLast30Days",
        key: "visitsLast30Days",
        width: 100,
        onCell: (_, index) => ({
          className: "text-right",
        }),
        render: (text, record) =>
          text === "-" ? text : formatNumber(Number(text), 0),
      },
      //  Lượt tải Catalogue
      {
        title: t("unidentified.luot-tai"),
        dataIndex: "catalogDownloads",
        key: "catalogDownloads",
        width: 100,
        onCell: (_, index) => ({
          className: "text-right",
        }),
        render: (text, record) =>
          text === "-" ? text : formatNumber(Number(text), 0),
      },
      //  Số lượng sp yêu thích
      {
        title: t("unidentified.sp-yt"),
        dataIndex: "numberOfFavoriteProducts",
        key: "numberOfFavoriteProducts",
        width: 100,
        onCell: (_, index) => ({
          className: "text-right",
        }),
        render: (text, record) =>
          text === "-" ? text : formatNumber(Number(text), 0),
      },
      //  Lượt đk map mẫu
      {
        title: t("unidentified.dk-map"),
        dataIndex: "numberOfColorMap",
        key: "numberOfColorMap",
        width: 100,
        onCell: (_, index) => ({
          className: "text-right",
        }),
        render: (text, record) =>
          text === "-" ? text : formatNumber(Number(text), 0),
      },
    ]);
    // ============================================ XỬ LÝ TABS =========================================

    useEffect(() => {
      if (typeTab) {
        switch (typeTab) {
          case "create":
            break;
          case "detail":
            break;
          default:
            break;
        }
      } else {
        navigate(ROUTES.CUSTOMER.CUSTOMER_UNIDENTIFIED.LINK);
      }
    }, []);

    const modules = {
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link", "image"],
        ["clean"],
      ],
    };



    // ================================ LẤY DROPDOWN ===========================================================
    const getListSaleOrg = async () => {
      await commonPresenter.getListSaleOrg(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListSaleOrg(commonStore.commonRespone.data);
      }
    };

    useEffect(() => {
      getListSaleOrg();
    }, []);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t("page-title.kh-cdd"),
            to: ROUTES.CUSTOMER.CUSTOMER_UNIDENTIFIED.LINK,
          },
          {
            text: "Thêm mới",
          },
        ]}
        extras={
          <>
            <CustomButton
              onClick={() => {
                form.submit();
              }}
              type="default"
              icon={<Download className="!fill-black" />}
            >
              {t("btn.save")}
            </CustomButton>
            <CustomButton
              onClick={() => {
                form.submit();
              }}
              type="primary"
              icon={<Download className="!fill-white" />}
            >
              Lưu và tiếp tục
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <Tabs
            type="line"
            size={"small"}
            className={
              "[&_.ant-tabs-tab]:!rounded-t-sm [&_.ant-tabs-tab]:!text-default [&_.ant-tabs-tab]:!font-semibold [&_.ant-tabs-tab:hover]:!text-primary [&_.ant-tabs-tab]:!border-gray-300 " +
              "[&>.ant-tabs-nav_.ant-tabs-tab.ant-tabs-tab-active]:!bg-white [&_.ant-tabs-tab-active]:!border-b-white [&_.ant-tabs-tab-active>div]:!text-primary [&_.ant-tabs-nav]:!mb-0 [&_.ant-tabs-nav::before]:!border-b-gray-300 " +
              "[&_.ant-tabs-nav-add]:!border [&_.ant-tabs-nav-add]:!border-gray-300 [&_.ant-tabs-ink-bar]:!bg-primary"
            }
            items={[
              {
                label: t("segment.tt-chung"),
                key: "1",
                children: (
                  <div className="my-3">
                    <SearchForm
                      onFinish={async (value) => {

                        const tempt = {
                          ...value,
                          customerAnonymousId: stateProps.state,
                          sendTime: value.sendTime ? dayjs(value.sendTime)?.format(DATE_FORMAT_POST) : undefined
                        }
                        await customerUnindentifiedPresenter.createCampaignAnonymous(customerUnindentifiedStore, tempt)
                        if (customerUnindentifiedStore.createUpdate.isSuccess) {
                          message.success(customerUnindentifiedStore.createUpdate.message)
                        }
                      }}
                      form={form}>
                      <div className="flex flex-col gap-1">
                        {/* Tiêu đề thông báo  */}
                        <SearchItem
                          name={"contactSegmentName"}
                          rules={[{ required: true, message: 'Hãy nhập thông tin' }]}
                          label={t("unidentified.messages-title")}
                        >
                          <CustomInputString />
                        </SearchItem>
                        {/* Công ty */}
                        <SearchItem
                          name={"companyCode"}
                          label={t("unidentified.company")}
                        >
                          <CustomSelect
                            options={listSaleOrg}
                            allowClear
                            showSearch
                            fieldNames={{ label: "value", value: "key" }}
                            filterOption={(input, option) =>
                              (option?.value ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </SearchItem>
                        {/* Nội dung thông báo */}
                        <SearchItem
                          name={"contentCampaign"}
                          label={t("unidentified.messages-content")}
                        >
                          <ReactQuill
                            theme="snow"
                            modules={modules}
                            value={editorContent}
                            onChange={(value) => setEditorContent(value)}
                          // onChange={console.log}
                          />
                        </SearchItem>
                      </div>
                      <div className="">
                        {/* Mô tả */}
                        <SearchItem
                          name={"description"}
                          label={t("unidentified.mo-ta")}
                        >
                          <Input.TextArea rows={4} />
                        </SearchItem>
                        {/* Mã chiến dịch */}
                        <SearchItem
                          name={"campaignCode"}
                          label={t("unidentified.ma-cd")}
                        >
                          <Input />
                        </SearchItem>

                        {/* Ngày tạo */}
                        <SearchItem name={'sendTime'} className='!w-full' label={t('search-form.create-date')}>
                          <DatePicker format={'DD/MM/YYYY'} />
                        </SearchItem>
                        {/* Gửi ngay lập tức */}
                        <div className='flex gap-2 items-center mt-2'>
                          <SearchItem name={'isSend'} valuePropName='checked' >
                            <Checkbox />
                          </SearchItem>
                          <div>{t('unidentified.send-immediately')}</div>
                        </div>

                        {/* <div
                          dangerouslySetInnerHTML={{ __html: editorContent }}
                        ></div> */}
                      </div>
                      {/* <Editor></Editor> */}


                    </SearchForm>
                  </div>
                ),
              },

              {
                label: t("unidentified.ds-tb-gui"),
                key: "3",
                children: (
                  <div className="my-3">
                    <CustomProTable<CustomerUnidentifiedModel>
                      bordered
                      columns={columns}
                      // dataSource={dataTable}
                      handleResize={() => { }}
                      // actionRef={tableRef}
                      // request={async (params = {}, sort, filter) => {
                      //   const data = await getDataTable({
                      //     ...dataPaging,
                      //     paging: {
                      //       ...dataPaging.paging,
                      //       orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      //       orderByDesc:
                      //         Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      //     },
                      //   });

                      //   if (Object.values(sort).length) {
                      //     setDataPaging({
                      //       ...dataPaging,
                      //       paging: {
                      //         ...dataPaging.paging,
                      //         orderBy:
                      //           Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      //         orderByDesc:
                      //           Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      //       },
                      //     });
                      //   }
                      //   return {
                      //     data: data,
                      //     success: contactSegmentStore.listContactSegment.isSuccess,
                      //   };
                      // }}
                      rowKey="stt"
                      // pagination={{
                      //   ...tablePagination(dataPaging, setDataPaging),
                      //   total: contactSegmentStore.listContactSegment.paging?.totalCount,
                      // }}
                      options={{
                        setting: false,
                        density: false,
                        fullScreen: false,
                        reload: false,
                      }}
                    />
                  </div>
                ),
              },
            ]}
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
};

export default createDetailCustomerUnidentified;
